import { Injectable } from "@angular/core";
import { ApiService } from "./Api.service";

@Injectable({
  providedIn: "root",
})
export class ObservationsService {
  constructor(private apiService: ApiService) {}

  async getObservationById(observationId: string) {
    try {
      let url = `observations/${observationId}`;

      return await this.apiService.get(url);
    } catch (error) {
      return error;
    }
  }
  
  async getStatisticsById(observationId: string) {
    try {
      let url = `observations/${observationId}/stadistic`;

      return await this.apiService.get(url);
    } catch (error) {
      return error;
    }
  }

  async getProfileData() {
    try {
      const response: { data: any } = await this.apiService.get("me");
      localStorage.setItem("user", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      return error;
    }
  }
  async getCenters() {
    try {
      let query = `?per_page=2000&type=centers`;
      return await this.apiService.get(`categories${query}`);
    } catch (error) {
      return error;
    }
  }

  async getLocals(unitId: string) {
    try {
      let query = `?per_page=2000&parent=${unitId}`;

      return await this.apiService.get(`categories${query}`);
    } catch (error) {
      return error;
    }
  }

  async getUnits(centerId: string) {
    try {
      let query = `?per_page=2000&parent=${centerId}`;
      return await this.apiService.get(`categories${query}`);
    } catch (error) {
      return error;
    }
  }

  async createObservation(observerForm: any) {
    try {
      let url = `observations`;
      console.log(observerForm);

      return await this.apiService.post(url, observerForm);
    } catch (error) {
      return error;
    }
  }
  async patchObservation(dateTime: any, observationId: string) {
    try {
      let url = `observations/${observationId}`;

      return await this.apiService.put(url, { end_date: dateTime });
    } catch (error) {
      return error;
    }
  }

  /////////////////////
  // Observations notes
  ////////////////////
  async addNote(observationId: string, note: any) {
    try {
      let url = `notes/${observationId}`;

      return await this.apiService.post(url, note);
    } catch (error) {
      return error;
    }
  }
}
